import React from 'react';

const Logo = () => {
  return (
    <div className="logo">
      <div className="logo-icon">
        <svg width="32" height="28" viewBox="0 0 400 350" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#6366f1" /> {/* Primary color */}
              <stop offset="100%" stopColor="#8b5cf6" /> {/* Accent color */}
            </linearGradient>
          </defs>
          <g className="logo-animation">
            {/* Top small dots */}
            <circle className="dot wave-3" cx="225" cy="62" r="8" fill="url(#logoGradient)"/>
            <circle className="dot wave-3" cx="300" cy="62" r="8" fill="url(#logoGradient)"/>
            
            {/* First row */}
            <circle className="dot wave-2" cx="150" cy="100" r="14" fill="url(#logoGradient)"/>
            <circle className="dot wave-2" cx="225" cy="100" r="14" fill="url(#logoGradient)"/>
            <circle className="dot wave-2" cx="300" cy="100" r="14" fill="url(#logoGradient)"/>
            <circle className="dot wave-2" cx="375" cy="100" r="14" fill="url(#logoGradient)"/>
            
            {/* Second row */}
            <circle className="dot wave-1" cx="110" cy="150" r="8" fill="url(#logoGradient)"/>
            <circle className="dot wave-1" cx="150" cy="150" r="14" fill="url(#logoGradient)"/>
            <circle className="center-dot wave-1" cx="225" cy="150" r="30" fill="url(#logoGradient)"/>
            <circle className="center-dot wave-1" cx="300" cy="150" r="30" fill="url(#logoGradient)"/>
            <circle className="dot wave-1" cx="375" cy="150" r="14" fill="url(#logoGradient)"/>
            <circle className="dot wave-1" cx="415" cy="150" r="8" fill="url(#logoGradient)"/>
            
            {/* Third row */}
            <circle className="dot wave-2" cx="110" cy="225" r="8" fill="url(#logoGradient)"/>
            <circle className="dot wave-2" cx="150" cy="225" r="14" fill="url(#logoGradient)"/>
            <circle className="center-dot wave-2" cx="225" cy="225" r="30" fill="url(#logoGradient)"/>
            <circle className="center-dot wave-2" cx="300" cy="225" r="30" fill="url(#logoGradient)"/>
            <circle className="dot wave-2" cx="375" cy="225" r="14" fill="url(#logoGradient)"/>
            <circle className="dot wave-2" cx="415" cy="225" r="8" fill="url(#logoGradient)"/>
            
            {/* Fourth row */}
            <circle className="dot wave-3" cx="150" cy="275" r="14" fill="url(#logoGradient)"/>
            <circle className="dot wave-3" cx="225" cy="275" r="14" fill="url(#logoGradient)"/>
            <circle className="dot wave-3" cx="300" cy="275" r="14" fill="url(#logoGradient)"/>
            <circle className="dot wave-3" cx="375" cy="275" r="14" fill="url(#logoGradient)"/>
            
            {/* Bottom small dots */}
            <circle className="dot wave-4" cx="225" cy="325" r="8" fill="url(#logoGradient)"/>
            <circle className="dot wave-4" cx="300" cy="325" r="8" fill="url(#logoGradient)"/>
          </g>
        </svg>
      </div>
      Aledger
    </div>
  );
};

export default Logo;
